<script setup>
import { defineProps, defineEmits  } from "vue";
defineProps({
  stateKey: {
    type: String,
    default: "",
  },
  config: {
    type: Object,
    default: null
  },
  accountModule: {
    type: Object,
    default: null
  },
  activeNav: {
    type: String,
    default: ''
  }
});

const $emitEvents = defineEmits(["onChange"]);

const changeView = (view) => {
  $emitEvents("change", view);
}


</script>

<template>
  <ul class="csr-account-nav__content">
    <li :class="[activeNav === accountModule.MY_ACCOUNT ? 'csr-account-nav__item active': 'csr-account-nav__item']" @click="() => changeView(accountModule.MY_ACCOUNT)">
      {{ config.accountModuleLabel }}
    </li>
    <li v-if="config.orderModuleLabel" :class="[activeNav === accountModule.MY_ORDER ? 'csr-account-nav__item active': 'csr-account-nav__item']"  @click="() => changeView(accountModule.MY_ORDER)">
      {{ config.orderModuleLabel }}
    </li>
    <!-- <li v-if="config.myProductModuleLabel" :class="[activeNav === accountModule.MY_PRODUCT ? 'csr-account-nav__item active': 'csr-account-nav__item']"  @click="() => changeView(accountModule.MY_PRODUCT)">
      {{ config.myProductModuleLabel }}
    </li> -->
  </ul>
</template>